<div class="sub-nav-for-mobile">{{activeLabel}}</div>
